import React, { PureComponent, Fragment, createRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import Link from 'next/link';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  PostalCodeElement,
  injectStripe,
} from 'react-stripe-elements';
import * as Yup from 'yup';
import { bindActionCreators } from 'redux';
import { Formik, Form } from 'formik';
import { connect } from 'react-redux';
import { CardSelect } from '../index';
import { Checkbox, Button } from '../../components';
import {
  InvalidCross,
  getCardBrandIcon,
  axiosInstance,
  objectIsEmpty,
} from '../../utils';
import { openModal } from '../../redux/actions';
import UpgradeToCabanaModal from '../UpgradeToCabanaModal';
import {HotelPanelNote} from "../HotelPanel/styles"

import {
  OptionsSubHeading,
  CheckboxDescription,
  CardInputContainer,
  CardInputRow,
  CheckboxList,
  ClientInfoHeading,
  ClientInfoList,
  ClientInfoNote,
  InfoInputErrorTooltip,
  InfoInputContainer,
  StripeInput,
  CardIcon,
  InfoInput,
  PayButton,
  PayButtonContainer,
  GuestLoginContainer,
  GuestLoginHeading,
  GuestLoginButtonContainer,
  PaymentProcessError,
  RulesDropdown,
  baseInputStyle,
} from "../PaymentForm/styles";

const mapStateToProps = state => ({
  userHotel: state.userProduct.hotel,
  userPreferences: state.userPreferences,
  guests: state.userPreferences.guests,
  products: state.userProduct.hotel.products,
  maxGuests: state.userProduct.product.maxGuests,
  type: state.userProduct.product.type,
  price: state.userProduct.product.price.total,
  userData: state.user.userData,
  usingCredits: state.payment.usingCredits,
  isPaying: state.bookingManagement.changeCheckingDate.isPaying,
  bookingManagement: state.bookingManagement,
  promo: state.promo,
  openedModal: state.ui.openedModal,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  handleModalOpenClick: openModal,
}, dispatch);

@injectStripe
@connect(mapStateToProps, mapDispatchToProps)
class PaymentWizard extends PureComponent {
  static propTypes = {
    setUpFieldInstances: PropTypes.func,
    handleFormSubmit: PropTypes.func,
    handleLoginButtonClick: PropTypes.func,
    handleCardElementsInput: PropTypes.func,
    baseInitialValues: PropTypes.instanceOf(Object),
    baseScheme: PropTypes.instanceOf(Object),
    cardErrors: PropTypes.instanceOf(Object),
    userData: PropTypes.instanceOf(Object),
    userHotel: PropTypes.instanceOf(Object),
    userPreferences: PropTypes.instanceOf(Object),
    status: PropTypes.string,
    brand: PropTypes.string,
    payingWith: PropTypes.instanceOf(Object),
    error: PropTypes.string,
    promo: PropTypes.instanceOf(Object),
    bookingManagement: PropTypes.instanceOf(Object),
    isPaying: PropTypes.bool,
    guests: PropTypes.number,
    usingCredits: PropTypes.bool,
    maxGuests: PropTypes.number,
    price: PropTypes.number,
  };

  form = createRef();

  cardNumber = createRef();

  cardExpiry = createRef();

  cardCvc = createRef();

  postalCode = createRef();

  state = {
    values: null,
    filteredUpgradeVariants: null,
    upgradeWasShown: false,
  };

  componentDidMount() {
    const { setUpFieldInstances } = this.props;
    setUpFieldInstances(this.cardNumber.current, this.cardExpiry.current, this.cardCvc.current, this.postalCode.current);
  }

  componentDidUpdate(prevProps) {
    const { userData: oldData, payingWith: oldPaymentMethod } = prevProps;
    const { userData: newData, payingWith: newPaymentMethod, setUpFieldInstances } = this.props;

    if (JSON.stringify(oldData) !== JSON.stringify(newData) || JSON.stringify(oldPaymentMethod)!== JSON.stringify(newPaymentMethod)) {
      setUpFieldInstances(this.cardNumber.current, this.cardExpiry.current, this.cardCvc.current, this.postalCode.current);
    }
  }

  onEmailBlur = async (evt, formikHandleBlurFunc) => {
    formikHandleBlurFunc(evt);

    if (!this.form.current.state.errors.emailAddress) {
      try {
        const { target: { value } } = evt;
        await axiosInstance.post('users/validate_email', { email: value });
      } catch (error) {
        this.form.current.setFieldError('emailAddress', error)
      }
    }
  };

   onFormSubmit = async values => {
    const { handleFormSubmit, guests, type, handleModalOpenClick, products, isPaying, userPreferences } = this.props;
    let filteredUpgradeVariants = null;
    const cabanasAndDaybedsAvailableForUpgrade = products.filter(e => e.type === 1 || e.type === 3);

    const arrayOfPromises = cabanasAndDaybedsAvailableForUpgrade.map((e) => new Promise(async (resolve, reject) => {
      try {
        const { data } = await axiosInstance.get(`products/tickets/${e.id}`);
        resolve({...data, ...e});
      } catch (err) {
        reject(err);
      }

    }));
    await Promise.all(arrayOfPromises)
      .then( val => {
        filteredUpgradeVariants = cabanasAndDaybedsAvailableForUpgrade.filter( upgradeVariand => {
          const prodCapacity = val.find(prod => prod.id === upgradeVariand.id);
          const customCapacityOnUserDate = prodCapacity.capacity.find(capacityDates => capacityDates.date === userPreferences.date);

          if(customCapacityOnUserDate && customCapacityOnUserDate.tickets * upgradeVariand.maxGuests >= guests) {
            return true;
          } if ( typeof customCapacityOnUserDate === 'undefined') {
            return prodCapacity.capacityByDay[moment(userPreferences.date).day()] * upgradeVariand.maxGuests >= guests;
          }
          return false;
        })
      })
      .catch(e => console.log(e))

    const isUpgradeAvailable = filteredUpgradeVariants.length && guests > 1 && type === 0 && !isPaying && !this.state.upgradeWasShown;
    if (isUpgradeAvailable ) {
      this.setState({
        filteredUpgradeVariants, 
        values,
        upgradeWasShown: true,
      });
      handleModalOpenClick('upgradeCabana');
    } else {
      handleFormSubmit(values, 'checkout');
    };

  };

  calculateTotalWithPromo = (countedPrice) => {
    const {
      promo: {
        info: {
          type: promoType,
          amount: promoAmount,
        }
      }
    } = this.props;


    switch (Number(promoType)) {
      case 0:
        return (countedPrice * ((100 - promoAmount) / 100)).toFixed(2);
      case 1:
        return countedPrice - promoAmount >= 0 ? (countedPrice - promoAmount).toFixed(2) : 0;
      default:
        return countedPrice.toFixed(2);
    }
  };

  render() {
    const { onFormSubmit, onEmailBlur } = this;
    const { values, filteredUpgradeVariants } = this.state;
    const { userHotel,handleFormSubmit , bookingManagement, promo, isPaying, openedModal, userPreferences, cardErrors, usingCredits, brand, handleLoginButtonClick, userData, status, handleCardElementsInput, baseScheme, baseInitialValues, payingWith, guests, error, maxGuests, price, } = this.props;
    const { cardNumber, cardExpiry, cardCvc, postalCode } = cardErrors;
    
    let productAmount;
    let countedPrice;
    let isCreditsEnough;

    let hasFreePass;

    if (userData) {
      const { last24freeDayPass, credits: { total }, subscription} = userData;
      productAmount = Math.ceil(guests / maxGuests);

      const type = isPaying ? bookingManagement.hotel.type : userHotel.hotelType;
      const date = isPaying ? bookingManagement.changeCheckingDate.newDate : userPreferences.date;

      hasFreePass = !isPaying && userData && !objectIsEmpty(subscription) && !last24freeDayPass && type === 0 && moment(date).isBefore(moment().add(1, 'day'))
      countedPrice = (hasFreePass ? productAmount - 1 : productAmount) * price;
      countedPrice = promo.status === 'success' && !isPaying ? this.calculateTotalWithPromo(countedPrice) : countedPrice;

      if (usingCredits) {
        isCreditsEnough = total > countedPrice;
      }
    }

    const initialValues = {
      ...baseInitialValues,
      terms: false,
      checkInDate: false,
      hotelRules: false,
    };

    const WizardScheme = Yup.object().shape({
      ...baseScheme,
      terms: Yup.boolean().oneOf([true], 'You must accept Terms & Conditions'),
      checkInDate: Yup.boolean().oneOf([true], 'You must accept date of check-in'),
      hotelRules: Yup.boolean().oneOf([true], 'You must agree with Hotel rules'),
    });

    const CardWizardScheme = Yup.object().shape({
      terms: Yup.boolean().oneOf([true], 'You must accept Terms & Conditions'),
      checkInDate: Yup.boolean().oneOf([true], 'You must accept date of check-in'),
      hotelRules: Yup.boolean().oneOf([true], 'You must agree with Hotel rules'),
    });
  
    return (
      <article>
        {openedModal === 'upgradeCabana' && <UpgradeToCabanaModal formFunc={handleFormSubmit} formData={values} filteredUpgradeVariants={filteredUpgradeVariants} multi={filteredUpgradeVariants && filteredUpgradeVariants.length > 1} />}
        <GuestLoginContainer>
          <GuestLoginHeading>Guest check-in information</GuestLoginHeading>
          {!userData && (
            <GuestLoginButtonContainer>
              <Button htmlType="button" theme="secondary" onClick={() => handleLoginButtonClick('login')}>Login</Button>
            </GuestLoginButtonContainer>
          )}
          {status === 'hasAccount' && <PaymentProcessError>Looks like you already have an account. Please, log in</PaymentProcessError>}
          {status === 'failure' && <PaymentProcessError>{error || <Fragment>There is a problem with your purchase. Our engineers have been notified. Please try again later or contact our customer service for more details.</Fragment>}</PaymentProcessError>}
        </GuestLoginContainer>
        <OptionsSubHeading>Pay with:</OptionsSubHeading>
        <CardSelect />
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={payingWith && !isCreditsEnough && (payingWith.value === 'newCard' || payingWith.value === 'paypal') ? WizardScheme : CardWizardScheme}
          onSubmit={onFormSubmit}
          ref={this.form}
        >
          {({ errors, touched, handleBlur, handleChange, values }) => (
            <Form>
              {payingWith && !(isCreditsEnough && usingCredits) && (payingWith.value === 'newCard' || payingWith.value === 'paypal') ? (
                <Fragment>
                  <ClientInfoList>
                    <li>
                      <ClientInfoHeading htmlFor="firstName">First name</ClientInfoHeading>
                      <InfoInputContainer hasError={errors.firstName && touched.firstName}>
                        <InfoInput
                          mask={false}
                          value={values.firstName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="firstName"
                          id="firstName"
                          placeholder="Enter first name"
                          type="text"
                        />
                        {errors.firstName && touched.firstName && (
                          <InfoInputErrorTooltip
                            content={errors.firstName}
                            placement="left"
                            fadeDuration={100}
                            padding={20}
                            radius={6}
                            background="#ffffff"
                            color="#5a5a5a"
                            border="#ebebeb"
                          >
                            <InvalidCross color="#ff4e72" />
                          </InfoInputErrorTooltip>
                        )}
                      </InfoInputContainer>
                    </li>
                    <li>
                      <ClientInfoHeading htmlFor="lastName">Last name</ClientInfoHeading>
                      <InfoInputContainer hasError={errors.lastName && touched.lastName}>
                        <InfoInput
                          mask={false}
                          value={values.lastName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="lastName"
                          id="lastName"
                          placeholder="Enter last name"
                          type="text"
                        />
                        {errors.lastName && touched.lastName && (
                          <InfoInputErrorTooltip
                            content={errors.lastName}
                            placement="left"
                            fadeDuration={100}
                            padding={20}
                            radius={6}
                            background="#ffffff"
                            color="#5a5a5a"
                            border="#ebebeb"
                          >
                            <InvalidCross color="#ff4e72" />
                          </InfoInputErrorTooltip>
                        )}
                      </InfoInputContainer>
                    </li>
                    {payingWith.value === 'newCard' && (
                      <li>
                        <ClientInfoHeading htmlFor="card">Card</ClientInfoHeading>
                        <CardInputContainer>
                          <CardInputRow>
                            <InfoInputContainer>
                              <StripeInput
                                style={{ borderTopRightRadius: 6, borderTopLeftRadius: 6 }}
                              >
                                <CardNumberElement style={{ ...baseInputStyle }} onChange={handleCardElementsInput} ref={this.cardNumber} />
                              </StripeInput>
                              <CardIcon>
                                {getCardBrandIcon(brand)}
                              </CardIcon>
                              {cardNumber && (
                                <InfoInputErrorTooltip
                                  content={cardNumber}
                                  style={{ right: getCardBrandIcon(brand) ? 70 : 20 }}
                                  placement="left"
                                  fadeDuration={100}
                                  padding={20}
                                  radius={6}
                                  background="#ffffff"
                                  color="#5a5a5a"
                                  border="#ebebeb"
                                >
                                  <InvalidCross color="#ff4e72" />
                                </InfoInputErrorTooltip>
                              )}
                            </InfoInputContainer>
                          </CardInputRow>
                          <CardInputRow>
                            <InfoInputContainer hasError={errors.cardExpiration && touched.cardExpiration}>
                              <StripeInput>
                                <CardExpiryElement style={{ ...baseInputStyle }} onChange={handleCardElementsInput} ref={this.cardExpiry} />
                              </StripeInput>
                              {cardExpiry && (
                                <InfoInputErrorTooltip
                                  content={cardExpiry}
                                  placement="left"
                                  fadeDuration={100}
                                  padding={20}
                                  radius={6}
                                  background="#ffffff"
                                  color="#5a5a5a"
                                  border="#ebebeb"
                                >
                                  <InvalidCross color="#ff4e72" />
                                </InfoInputErrorTooltip>
                              )}
                            </InfoInputContainer>
                            <InfoInputContainer hasError={errors.cvc && touched.cvc}>
                              <StripeInput>
                                <CardCVCElement style={{ ...baseInputStyle }} onChange={handleCardElementsInput} ref={this.cardCvc} />
                              </StripeInput>
                              {cardCvc && (
                                <InfoInputErrorTooltip
                                  content={cardCvc}
                                  placement="left"
                                  fadeDuration={100}
                                  padding={20}
                                  radius={6}
                                  background="#ffffff"
                                  color="#5a5a5a"
                                  border="#ebebeb"
                                >
                                  <InvalidCross color="#ff4e72" />
                                </InfoInputErrorTooltip>
                              )}
                            </InfoInputContainer>
                          </CardInputRow>
                          <CardInputRow>
                            <InfoInputContainer hasError={errors.zipCode && touched.zipCode}>
                              <StripeInput
                                style={{ borderBottomLeftRadius: 6, borderBottomRightRadius: 6 }}
                              >
                                <PostalCodeElement style={{ ...baseInputStyle }} onChange={handleCardElementsInput} ref={this.postalCode} />
                              </StripeInput>
                              {postalCode && (
                                <InfoInputErrorTooltip
                                  content={postalCode}
                                  placement="left"
                                  fadeDuration={100}
                                  padding={20}
                                  radius={6}
                                  background="#ffffff"
                                  color="#5a5a5a"
                                  border="#ebebeb"
                                >
                                  <InvalidCross color="#ff4e72" />
                                </InfoInputErrorTooltip>
                              )}
                            </InfoInputContainer>
                          </CardInputRow>
                        </CardInputContainer>
                      </li>
                    )}
                    <li style={{display: userData ? 'none' : 'list-item'}}>
                      <ClientInfoHeading htmlFor="emailAddress">E-mail</ClientInfoHeading>
                      <InfoInputContainer hasError={errors.emailAddress && touched.emailAddress}>
                        <InfoInput
                          mask={false}
                          value={values.emailAddress}
                          onChange={handleChange}
                          onBlur={evt => onEmailBlur(evt, handleBlur)}
                          name="emailAddress"
                          id="emailAddress"
                          placeholder="Enter e-mail"
                          type="email"
                        />
                        {errors.emailAddress && touched.emailAddress && (
                          <InfoInputErrorTooltip
                            content={errors.emailAddress}
                            placement="left"
                            fadeDuration={100}
                            padding={20}
                            radius={6}
                            background="#ffffff"
                            color="#5a5a5a"
                            border="#ebebeb"
                          >
                            <InvalidCross color="#ff4e72" />
                          </InfoInputErrorTooltip>
                        )}
                      </InfoInputContainer>
                      <ClientInfoNote withError={errors.emailAddress === 'User with this email already exists'}>{errors.emailAddress === 'User with this email already exists' ? errors.emailAddress : 'A booking confirmation will be sent to this address'}</ClientInfoNote>
                    </li>
                    <li>
                      <ClientInfoHeading htmlFor="phone">Phone</ClientInfoHeading>
                      <InfoInputContainer hasError={errors.phone && touched.phone}>
                        <InfoInput
                          mask={['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                          guide={false}
                          value={values.phone}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="phone"
                          id="phone"
                          placeholder="+1 (800) XXX-XXXX"
                          type="tel"
                        />
                        {errors.phone && touched.phone && (
                          <InfoInputErrorTooltip
                            content={errors.phone}
                            placement="left"
                            fadeDuration={100}
                            padding={20}
                            radius={6}
                            background="#ffffff"
                            color="#5a5a5a"
                            border="#ebebeb"
                          >
                            <InvalidCross color="#ff4e72" />
                          </InfoInputErrorTooltip>
                        )}
                      </InfoInputContainer>
                    </li>
                  </ClientInfoList>
                </Fragment>
              ) : null}
              <CheckboxList>
                <li>
                  <Checkbox
                    blue
                    invalid={Boolean(errors.terms) && Boolean(touched.terms)}
                    name="terms"
                    value="terms"
                    id="terms"
                    label={(
                      <CheckboxDescription hasError={errors.terms  && touched.terms}>
                        By completing my order I agree with{' '}
                        <Link href="/terms">
                          <a target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
                        </Link>
                      </CheckboxDescription>
                    )}
                    onChange={handleChange}
                    handleBlur={handleBlur}
                    checked={values.terms}
                  />
                </li>
                <li>
                  <Checkbox
                    blue
                    invalid={Boolean(errors.checkInDate) && Boolean(touched.checkInDate)}
                    name="checkInDate"
                    value="checkInDate"
                    id="checkInDate"
                    label={(
                      <CheckboxDescription hasError={errors.checkInDate && touched.checkInDate}>
                        I confirm the date of check-in is {moment(userPreferences.date).format('MMM DD, YYYY')}
                      </CheckboxDescription>
                    )}
                    onChange={handleChange}
                    handleBlur={handleBlur}
                    checked={values.checkInDate}
                  />
                </li>
                <li>
                  <Checkbox
                    blue
                    invalid={Boolean(errors.hotelRules) && Boolean(touched.hotelRules)}
                    name="hotelRules"
                    value="hotelRules"
                    id="hotelRules"
                    label={(
                      <CheckboxDescription hasError={errors.hotelRules && touched.hotelRules}>
                        I agree with {userHotel.name} rules
                      </CheckboxDescription>
                    )}
                    onChange={handleChange}
                    handleBlur={handleBlur}
                    checked={values.hotelRules}
                  />
                  <RulesDropdown>
                    {userHotel.finePrint.map(rule => <li key={rule}>{rule}</li>)}
                  </RulesDropdown>
                </li>
              </CheckboxList>
              <PayButtonContainer>
                <PayButton btnType="primary" type="submit" disabled={status === 'fetching'}>
                  {payingWith.value !== 'paypal' ? 'Confirm and Pay' : 'Login to PayPal'}
                </PayButton>
              </PayButtonContainer>
              <HotelPanelNote style={{float: 'left'}}>*Charges on the online statements will say 'DayAxe'</HotelPanelNote>
            </Form>
          )}
        </Formik>
      </article>
    );
  }
}

export default PaymentWizard;
